/**
 * Takes existing URL and reloads it to a new estimate by the given code.
 * @param estimateCode
 */
import { LOCAL_STORAGE_KEY } from '@common/constants';

export const alertWhenExiting = (e: Event) => {
    if (getIsDirtyState()) {
        e.preventDefault();
        e.returnValue = true; // required for chrome to alert
    }
};

export const setIsDirtyState = (value: boolean) => {
    sessionStorage.setItem(LOCAL_STORAGE_KEY.IS_DIRTY, value.toString());
};

export const getIsDirtyState = (): boolean => {
    const isDirty = sessionStorage.getItem(LOCAL_STORAGE_KEY.IS_DIRTY);
    return isDirty ? isDirty === 'true' : false;
};

/**
 * Update with current url with new searchParams (merged to existing)
 * @param searchParams object of key/value pairs for the new query string
 *  will update keys that are currently in the url, if undefined, will delete that key
 */
export const makeEEUrlWithNewCode = (searchParams: Record<string, string | undefined>): URL => {
    //start with our current location, complete with all query strings
    const url = new URL(document.location.href);

    for (const [key, value] of Object.entries(searchParams)) {
        url.searchParams.delete(key);
        if (value) {
            url.searchParams.append(key, value);
        }
    }
    return url;
};

export const openNewEstimateSameWindow = (estimateCode: string) => {
    setIsDirtyState(false);
    const searchParams: Record<string, string> = {};
    searchParams[LOCAL_STORAGE_KEY.LOAD_ESTIMATE] = estimateCode;
    document.location.href = makeEEUrlWithNewCode(searchParams).href;
};

/**
 * attempts to open a url in a new, _blank target tab/window
 * @param url the url
 */
export const openUrlInNewTab = (url: URL) => {
    setTimeout(async () => {
        window.open(url.toString(), '_blank');
    }, 0);
};
